export default __webpack_public_path__ + "static/media/MobileImageItemEn2.baec400a.png";